export default __webpack_public_path__ + "static/media/modern.488f93f3.jpg";